import { withRegisterSubmit } from '@psyomics/ui-common';
import { RegisterForm } from '@psyomics/ui-components';

import { CRISIS_ACKNOWLEDGED_KEY } from '../../app/crisis-acknowledgement';
import { PATIENT_REDIRECT_WHITELIST } from '../../app/redirect-whitelists';
import { getConfig } from '../../config';
import { usePatientAppBarContext } from '../../shared/contexts/patient-app-bar';

const RegisterWithSubmit = withRegisterSubmit(RegisterForm, {
  defaultMethod: 'phone',
  localStorageData: { [CRISIS_ACKNOWLEDGED_KEY]: 'true' },
  passwordLess: true,
  redirectWhitelist: PATIENT_REDIRECT_WHITELIST,
});

const SelfReferralRegister = ({ redirect }: { readonly redirect: string }) => {
  const { setShowUrgentHelp } = usePatientAppBarContext();
  const { patientApiUrl } = getConfig();

  return (
    <div className="w-full flex justify-center mt-8">
      <div className="w-full max-w-[327px] mx-[24px]">
        <RegisterWithSubmit
          apiUrl={patientApiUrl}
          onUrgentHelpClick={() => setShowUrgentHelp(true)}
          redirect={redirect}
        />
      </div>
    </div>
  );
};

export { SelfReferralRegister };
